import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';
import { forwardRef, useState } from "react";

const CustomInput = forwardRef((props, ref) => {

    let [value, updateValue] = useState(props.value?props.value:{});
    let className = '';

    const handleChange = element => {
        console.log(element);
        updateValue(element.target.value);
        props.onChange(element);
    };

    if (props.error) {
        className = "is-invalid";
    }
    return (
        <div ref={ref}>
            <JSONInput
                id={'id_' + props.name}
                placeholder={value}
                locale={locale}
                height={props.height}
                width={props.width}
                onChange={handleChange}
                className={className}
                value={value}
                type={props.type}
                name={props.name}
                readOnly={props.readOnly}
                autoFocus={props.autoFocus?true:false}
            />
            {props.error && (
                <span
                    class="error invalid-feedback"
                    style={{ display: 'inline' }}>
                    {props.error}
                </span>
            )}
        </div>
    );
})
export default CustomInput;
